import BaseAPI from '../base'

function sendApplication(data) {
    return BaseAPI.post(`join/apply`, data);
}

function checkApplication(id) {
    return BaseAPI.get(`join/check/${id}`);
}

function apply(data) {
    return BaseAPI.post(`join/apply`, data);
}

function check(id) {
    return BaseAPI.get(`join/check/${id}`);
}

function confirm(id, data) {
    return BaseAPI.post(`join/confirm/${id}`, data)
}

function confirmApplication(id, password) {
    return BaseAPI.post(`join/confirm/${id}`, {
        password
    });
}

function getFeatures() {
    return BaseAPI.get(`join/features`);
}

function activateCafe(code) {
    return BaseAPI.post(`join/activate`, {
        code
    });
}

function sendPosterApplication(account, code) {
    return BaseAPI.post(`join/apply/poster`, {
        account,
        code
    });
}

function getTimezones() {
    return BaseAPI.get(`join/timezones`);
}

export default {
    sendApplication,
    checkApplication,
    confirmApplication,
    getFeatures,
    activateCafe,
    sendPosterApplication,
    getTimezones,
    apply,
    check,
    confirm
}